import React from "react";
import "./TestResultCardChip.scss";
import { TestResultsChip } from "../../../interfaces";

const TestResultCardChip = (props: TestResultsChip) => {
  return (
      <div className="test-details">
        <div className="test-details-label">{props.title} : </div>
        <div className="test-details-value">{props.titleData}</div>
      </div>
  );
};

export default TestResultCardChip;
